import { AutorizacaoTipo } from './autorizacao-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class AutorizacaoTipoService {

    constructor(private http: Http) {
    }

    getAutorizacaoTipos(): Observable<AutorizacaoTipo[]> {
        return this.http.get(`${NTECH_API}/autorizacao-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/autorizacao-tipo/autorizacao-tipo.service.ts